(() => {
  function loadHoverImage(event) {
    const card = event.target.closest?.('.m-product-card');
    if (!card) return;
    const holder = card.querySelector('[data-mof-hover-image]');
    const template = holder?.querySelector('template');
    if (!template) return;
    holder.appendChild(template.content.cloneNode(true));
    template.remove();
  }
  document.addEventListener('pointerover', loadHoverImage, {passive: true});
  document.addEventListener('focusin', loadHoverImage);
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-mof-help-launcher]');
    if (!button || button.disabled) return;
    if (typeof window.zE === 'function') {
      window.zE('webWidget', 'show');
      window.zE('webWidget', 'open');
      return;
    }
    const label = button.querySelector('span');
    const originalLabel = label.textContent;
    button.disabled = true;
    label.textContent = button.dataset.loadingLabel;
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=76e794d8-861b-4ffa-8cd4-4c2b7e04b170';
    script.async = true;
    script.addEventListener('load', () => {
      button.disabled = false;
      label.textContent = originalLabel;
      if (typeof window.zE !== 'function') return;
      window.zE('webWidget:on', 'open', () => { button.hidden = true; });
      window.zE('webWidget', 'show');
      window.zE('webWidget', 'open');
    }, {once:true});
    script.addEventListener('error', () => {
      button.disabled = false;
      label.textContent = originalLabel;
      script.remove();
    }, {once:true});
    document.body.appendChild(script);
  });
})();
